// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js'; import './autoload/_js-cookie.js'; import './autoload/_rwdImageMaps.js'; import './autoload/_swiper.js'

import 'slick-carousel/slick/slick.min';
import 'jquery.flipster/dist/jquery.flipster.min';
import 'select2/dist/js/select2.min.js';

import Lightbox from 'bs5-lightbox';
window.Lightbox = Lightbox;

import SimpleBar from 'simplebar';
// import * as SimpleBar from 'simplebar';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleInteractiveMap from './routes/single-interactive-map';

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebookF, faTwitter, faInstagram, faVimeoV, faSoundcloud, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faAngleDoubleDown, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faUser, faCommentDots} from '@fortawesome/free-regular-svg-icons';


library.add(faAngleDoubleDown, faCommentDots, faFacebookF, faTwitter, faLinkedinIn, faSearch, faTimes, faVimeoV, faInstagram, faSoundcloud, faUser, faCalendarAlt);

dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  singleInteractiveMap,
});

/** VanilaJS adding listener to navigation to add style when navbar is affixed */
// document.addEventListener('DOMContentLoaded', () => {
//   if (window.scrollY >= 1) {
//     document.getElementsByTagName('body')[0].classList.add('affixed')
//   } else {
//     document.getElementsByTagName('body')[0].classList.remove('affixed')
//   }

//   window.addEventListener('scroll', () => {
//     if (window.scrollY >= 1) {
//       document.getElementsByTagName('body')[0].classList.add('affixed')
//     } else {
//       document.getElementsByTagName('body')[0].classList.remove('affixed')
//     }
//   })
// })

// export {SimpleBar};

// global.SimpleBar = require('simplebar/dist/simplebar');
// //global.SimpleBar = SimpleBar;


global.$ = global.jQuery = require('jquery');
// $('.simplebar').each(function() { 
//   new SimpleBar($(this), { autoHide: false })
// });

//$('.simplebar').each( new SimpleBar());
$('.simplebar').each(function(){ new SimpleBar(this,{
  autoHide: false,
})});
//  new SimpleBar(document.getElementById('simplebar'),{ 
//   autoHide: false,
//   // forceVisible: true,
// });
$(window).resize(function(){

});
// Load Events
jQuery(document).ready(function() {
  window.page_type = get_page_type()
  window.dataLayer.push({
    'event': 'page_type',
    'page_type': window.page_type,
  })

  routes.loadEvents()
});

/* eslint-disable no-unused-vars */
function get_page_type() {
  const classes = document.body.getAttribute('class').split(' ')

  let page_type = '';

  if (classes.includes('home')) {
    page_type = 'home'
  } else if (classes.includes('template-labnews')) {
    page_type = 'labnews_index'
  } else if (classes.includes('template-references')) {
    page_type = 'references_index'
  } else if (classes.includes('template-gcp')) {
    page_type = 'gcp'
  } else if (classes.includes('template-news')) {
    page_type = 'news_index'
  } else if (classes.includes('template-blog')) {
    page_type = 'blog_index'
  } else if (classes.includes('template-job-offers')) {
    page_type = 'job-offers_page'
  } else if (classes.includes('tax-reference_product_family')) {
    page_type = 'reference_product_family'
  } else if (classes.includes('tax-product_category')) {
    page_type = 'category_page'
  } else if (classes.includes('contact')) {
    page_type = 'contact_page'
  } else if (classes.includes('page')) {
    page_type = 'page'
  } else if (classes.includes('single-reference')) {
    page_type = 'reference_page'
  } else if (classes.includes('single-news')) {
    page_type = 'news_page'
  } else if (classes.includes('single-blog')) {
    page_type = 'blog_page'
  } else if (classes.includes('single-labnews')) {
    page_type = 'labnews_page'
  } else if (classes.includes('single-product')) {
    page_type = 'product_page'
  } else if (classes.includes('single-solution')) {
    page_type = 'solution_page'
  } else if (classes.includes('single-job-offer')) {
    page_type = 'job-offer'
  } else if (classes.includes('search-results')) {
    page_type = 'search-results'
  } else if (classes.includes('error404')) {
    page_type = '404'
  }

  return page_type
}
/* eslint-enable no-unused-vars */


// WEBPACK FOOTER //
// ./scripts/main.js